export class TranslationConstants {

  constructor(language) {
    // English
    const prescreenPageDOBEnglish = 'Date of Birth';
    const prescreenPageFTDEnglish = 'Are you a first-time donor at ';
    const prescreenPageGenderEnglish = 'Sex';
    const prescreenPageSelectOptionEnglish = 'Select an option';
    const prescreenPageMaleEnglish = 'Male';
    const prescreenPageFemaleEnglish = 'Female';
    const prescreenPageYesEnglish = 'Yes';
    const prescreenPageNoEnglish = 'No';
    const prescreenPageBackEnglish = 'Back';
    const prescreenPageContinueEnglish = 'Continue';
    const prescreenPageBirthdateEnglish = 'Birthdate';
    const prescreenPageAgeWarningEnglish = 'The Date of Birth entered indicates that you are %DONOR_AGE% year(s) old.';
    const prescreenPageWarningContinueEnglish = 'If this is correct, select Continue. Otherwise, select Back to modify the date.';
    const questionnairePageNextEnglish = 'Next';
    const questionnairePagePreviousEnglish = 'Previous';
    const questionnairePageReviewEnglish = 'Review';
    const questionnairePageReviewDonorAidEnglish = 'Please review this document';
    const questionnairePageDonorAidEnglish = 'View Document';
    const questionnaireQuestionEnglish = 'Question';
    const reviewPageReviewResponsesEnglish = 'Please scroll to the bottom to review your responses and generate your Donor Pass. Select a question to change your response.'
    const reviewPageEditEnglish = 'Edit';
    const reviewPageQuestionEnglish = 'Question';
    const reviewPageResponseEnglish = 'Response';
    const reviewPageReviewEnglish = 'Review';
    const reviewPageYesEnglish = 'Yes';
    const reviewPageNoEnglish = 'No';
    const reviewPageNotSureEnglish = 'Not Sure';
    const reviewPageDonorPassEnglish = 'Generate Donor Pass';
    const donorPageDonorPassEnglish = 'Donor Pass';
    const donorPageBarcodeEnglish = 'Barcode';
    const donorPassThankYouEnglish = 'Thank you for taking the Medical History Questionnaire for %BLOOD_CENTER_NAME%. Please bring this with you to the blood center.'
    const donorPassExpireEnglish = 'Donor Pass expires at midnight';
    const donorPassDownloadEnglish = 'Download';
    const donorPassPrintEnglish = 'Print';
    const donorPassEmailEnglish = 'Email';
    const donorPassReturnToEnglish = 'Return To';
    const donorPassStartOverEnglish = 'Start Over';
    const xpressDialogNavToBarcodeTitleEnglish = "Generate Donor Pass";
    const xpressDialogNavToBarcodeTextEnglish = "After this action, you can no longer return to review or modify your answers.";
    const xpressDialogNavToBarcodeOkEnglish = "OK";
    const xpressDialogNavToBarcodeCancelEnglish = "CANCEL";
    const xpressDialogSendEmailTitleEnglish = "Email Donor Pass";
    const xpressDialogSendEmailTextEnglish = "Email Address";
    const xpressDialogSendEmailSendEnglish = "Send";
    const xpressDialogSendEmailCancelEnglish = "Cancel";
    const xpressDialogValidDateTitleEnglish = "Invalid Date";
    const xpressDialogValidDateTextEnglish = "Please enter a valid birth date in the format MM/DD/YYYY.";
    const xpressDialogValidDateOkEnglish = "Ok";
    const xpressDialogPreScreenTitleEnglish = "Problem";
    const xpressDialogPreScreenTextEnglish = "Please complete the entire form on this page before proceeding";
    const xpressDialogPreScreenOkEnglish = "Ok";
    const poweredByEnglish = "Powered by IT Synergistics, LLC";
    const fileDownloadedModalTextEnglish = "Download initiated. Please save the file to your device if prompted.";
    const fileDownloadedModalTitleEnglish = "Download Donor Pass";
    const xpressEmailModalTextEnglish = "Please enter an e-mail address:";
    const xpressDialogEmailSuccessMessageEnglish = "Donor Pass email sent. Please check your spam folder if you do not receive it.";
    const xpressDialogEmailInvalidMessageEnglish = "Please enter a valid e-mail address";
    const xpressDialogTitleErrorEnglish = "Error";
    const xpressDialogTitleWarningEnglish = "Warning";

    // Spanish
    const prescreenPageDOBSpanish = 'Fecha de nacimiento';
    const prescreenPageFTDSpanish = '¿Eres una primera donante en ';
    const prescreenPageGenderSpanish = 'Sexo';
    const prescreenPageSelectOptionSpanish = 'Seleccione las opciones';
    const prescreenPageMaleSpanish = 'Masculino';
    const prescreenPageFemaleSpanish = 'Hembra';
    const prescreenPageYesSpanish = 'Sí';
    const prescreenPageNoSpanish = 'No';
    const prescreenPageBackSpanish = 'Anterior';
    const prescreenPageContinueSpanish = 'Continuar';
    const prescreenPageBirthdateSpanish = 'Fecha de nacimiento';
    const prescreenPageAgeWarningSpanish = 'La fecha de nacimiento ingresada indica que usted tiene %DONOR_AGE% año(s) de edad.';
    const prescreenPageWarningContinueSpanish = 'Si esto es correcto, seleccione Continuar. De lo contrario, seleccione Volver para modificar la fecha.';
    const questionnairePageNextSpanish = 'Siguiente';
    const questionnairePagePreviousSpanish = 'Anterior';
    const questionnairePageReviewDonorAidSpanish = 'Revise este documento por favor';
    const questionnairePageDonorAidSpanish = 'Ver Documento';
    const questionnairePageReviewSpanish = 'Revisar';
    const questionnaireQuestionSpanish = 'Pregunta';
    const reviewPageReviewResponsesSpanish= 'Desplácese hasta la parte inferior para revisar sus respuestas y generar su Pase de Donante. Seleccione una pregunta para cambiar su respuesta.'
    const reviewPageEditSpanish = 'Editar';
    const reviewPageQuestionSpanish = 'Pregunta';
    const reviewPageResponseSpanish = 'Respuesta';
    const reviewPageYesSpanish = 'Sí';
    const reviewPageNoSpanish = 'No';
    const reviewPageNotSureSpanish = 'No estoy seguro';
    const reviewPageDonorPassSpanish = 'Generar Pase de Donante';
    const donorPageDonorPassSpanish = 'Pase de Donante';
    const donorPageBarcodeSpanish = 'Pase de Donante';
    const donorPassThankYouSpanish = 'Gracias por completar el Cuestionario de historial médico de %BLOOD_CENTER_NAME%. Por favor traiga esto con usted al centro de sangre.';
    const donorPassExpireSpanish = 'El Pase de Donante vence a la medianoche';
    const donorPassDownloadSpanish = 'Descargar';
    const donorPassPrintSpanish = 'Imprimir';
    const donorPassEmailSpanish = 'Email';
    const donorPassReturnToSpanish = 'Volver a';
    const donorPassStartOverSpanish = 'Comenzar de nuevo';
    const xpressDialogNavToBarcodeTitleSpanish = "Navegando a código de barras";
    const xpressDialogNavToBarcodeTextSpanish = "Después de esta acción, ya no podrá volver a revisar o modificar sus respuestas.";
    const xpressDialogNavToBarcodeOkSpanish = "DE ACUERDO";
    const xpressDialogNavToBarcodeCancelSpanish = "CANCELAR";
    const xpressDialogSendEmailTitleSpanish = "Email";
    const xpressDialogSendEmailTextSpanish = "Dirección de correo electrónico";
    const xpressDialogSendEmailSendSpanish = "ENVIAR";
    const xpressDialogSendEmailCancelSpanish = "CANCELAR";
    const xpressDialogValidDateTitleSpanish = "Fecha Invalida";
    const xpressDialogValidDateTextSpanish = "Introduzca una fecha de nacimiento válida en el formato MM/DD/YYYY.";
    const xpressDialogValidDateOkSpanish = "DE ACUERDO";
    const xpressDialogPreScreenTitleSpanish = "Problema";
    const xpressDialogPreScreenTextSpanish = "Por favor complete el formulario completo en esta página antes de continuar";
    const xpressDialogPreScreenOkSpanish = "DE ACUERDO";
    const poweredBySpanish = "Provisto por IT Synergistics, LLC";
    const fileDownloadedModalTextSpanish = "Descarga iniciada. Guarde el archivo en su dispositivo si se le solicita.";
    const fileDownloadedModalTitleSpanish = "Descargar Pase de Donante";
    const xpressEmailModalTextSpanish = "Ingrese un correo eléctronico por favor:";
    const xpressDialogEmailSuccessMessageSpanish = "Se envió el correo electrónico del pase de donante. Revise su carpeta de correo no deseado si no lo recibe por favor.";
    const xpressDialogEmailInvalidMessageSpanish = "Ingrese un correo electrónico válido por favor";
    const xpressDialogTitleErrorSpanish = "Error";
    const xpressDialogTitleWarningSpanish = "Advertencia";


    if(language === '1')
    {
      this.prescreenPageBack = prescreenPageBackEnglish;
      this.prescreenPageContinue = prescreenPageContinueEnglish;
      this.prescreenPageDOB = prescreenPageDOBEnglish;
      this.prescreenPageFTD = prescreenPageFTDEnglish;
      this.prescreenPageGender = prescreenPageGenderEnglish;
      this.prescreenPageSelectOption = prescreenPageSelectOptionEnglish;
      this.prescreenPageMale = prescreenPageMaleEnglish;
      this.prescreenPageFemale = prescreenPageFemaleEnglish;
      this.prescreenPageYes = prescreenPageYesEnglish;
      this.prescreenPageNo = prescreenPageNoEnglish;
      this.prescreenPageBirthdate = prescreenPageBirthdateEnglish;
      this.prescreenPageAgeWarning = prescreenPageAgeWarningEnglish;
      this.prescreenPageWarningContinue = prescreenPageWarningContinueEnglish;
      this.questionnairePageNext = questionnairePageNextEnglish;
      this.questionnairePagePrevious = questionnairePagePreviousEnglish;
      this.questionnairePageReviewDonorAid = questionnairePageReviewDonorAidEnglish;
      this.questionnairePageDonorAid = questionnairePageDonorAidEnglish;
      this.questionnairePageReview = questionnairePageReviewEnglish;
      this.questionnaireQuestion = questionnaireQuestionEnglish;
      this.reviewPageReviewResponses = reviewPageReviewResponsesEnglish;
      this.reviewPageEdit = reviewPageEditEnglish;
      this.reviewPageQuestion = reviewPageQuestionEnglish;
      this.reviewPageResponse = reviewPageResponseEnglish;
      this.reviewPageYes = reviewPageYesEnglish;
      this.reviewPageNo = reviewPageNoEnglish;
      this.reviewPageNotSure = reviewPageNotSureEnglish;
      this.reviewPageDonorPass = reviewPageDonorPassEnglish;
      this.donorPageDonorPass = donorPageDonorPassEnglish;
      this.donorPageBarcode = donorPageBarcodeEnglish;
      this.donorPassThankYou = donorPassThankYouEnglish;
      this.donorPassExpire = donorPassExpireEnglish;
      this.donorPassDownload = donorPassDownloadEnglish;
      this.donorPassPrint = donorPassPrintEnglish;
      this.donorPassEmail = donorPassEmailEnglish;
      this.donorPassReturnTo = donorPassReturnToEnglish;
      this.donorPassStartOver = donorPassStartOverEnglish;
      this.xpressDialogNavToBarcodeTitle = xpressDialogNavToBarcodeTitleEnglish;
      this.xpressDialogNavToBarcodeText = xpressDialogNavToBarcodeTextEnglish;
      this.xpressDialogNavToBarcodeOk = xpressDialogNavToBarcodeOkEnglish;
      this.xpressDialogNavToBarcodeCancel = xpressDialogNavToBarcodeCancelEnglish;
      this.xpressDialogSendEmailTitle = xpressDialogSendEmailTitleEnglish;
      this.xpressDialogSendEmailText = xpressDialogSendEmailTextEnglish;
      this.xpressDialogSendEmailSend = xpressDialogSendEmailSendEnglish;
      this.xpressDialogSendEmailCancel = xpressDialogSendEmailCancelEnglish;
      this.xpressDialogValidDateTitle = xpressDialogValidDateTitleEnglish;
      this.xpressDialogValidDateText = xpressDialogValidDateTextEnglish;
      this.xpressDialogValidDateOk = xpressDialogValidDateOkEnglish;
      this.xpressDialogPreScreenTitle = xpressDialogPreScreenTitleEnglish;
      this.xpressDialogPreScreenText = xpressDialogPreScreenTextEnglish;
      this.xpressDialogPreScreenOk = xpressDialogPreScreenOkEnglish;
      this.xpressPoweredBy = poweredByEnglish;
      this.fileDownloadedModalText = fileDownloadedModalTextEnglish;
      this.fileDownloadedModalTitle = fileDownloadedModalTitleEnglish;
      this.xpressEmailModalText = xpressEmailModalTextEnglish;
      this.xpressDialogEmailSuccessMessage = xpressDialogEmailSuccessMessageEnglish;
      this.xpressDialogEmailInvalidMessage = xpressDialogEmailInvalidMessageEnglish;
      this.xpressDialogTitleError = xpressDialogTitleErrorEnglish;
      this.xpressDialogTitleWarning = xpressDialogTitleWarningEnglish;
    }

    if(language === '2'){
      this.prescreenPageBack = prescreenPageBackSpanish;
      this.prescreenPageContinue = prescreenPageContinueSpanish;
      this.prescreenPageDOB = prescreenPageDOBSpanish;
      this.prescreenPageFTD = prescreenPageFTDSpanish;
      this.prescreenPageGender = prescreenPageGenderSpanish;
      this.prescreenPageSelectOption = prescreenPageSelectOptionSpanish;
      this.prescreenPageMale = prescreenPageMaleSpanish;
      this.prescreenPageFemale = prescreenPageFemaleSpanish;
      this.prescreenPageYes = prescreenPageYesSpanish;
      this.prescreenPageNo = prescreenPageNoSpanish;
      this.prescreenPageBirthdate = prescreenPageBirthdateSpanish;
      this.questionnairePageNext = questionnairePageNextSpanish;
      this.questionnairePagePrevious = questionnairePagePreviousSpanish;
      this.questionnairePageReviewDonorAid = questionnairePageReviewDonorAidSpanish;
      this.questionnairePageDonorAid = questionnairePageDonorAidSpanish;
      this.questionnairePageReview = questionnairePageReviewSpanish;
      this.questionnaireQuestion = questionnaireQuestionSpanish;
      this.prescreenPageAgeWarning = prescreenPageAgeWarningSpanish;
      this.prescreenPageWarningContinue = prescreenPageWarningContinueSpanish;
      this.reviewPageReviewResponses = reviewPageReviewResponsesSpanish;
      this.reviewPageEdit = reviewPageEditSpanish;
      this.reviewPageQuestion = reviewPageQuestionSpanish;
      this.reviewPageResponse = reviewPageResponseSpanish;
      this.reviewPageYes = reviewPageYesSpanish;
      this.reviewPageNo = reviewPageNoSpanish;
      this.reviewPageNotSure = reviewPageNotSureSpanish;
      this.reviewPageDonorPass = reviewPageDonorPassSpanish;
      this.donorPageDonorPass = donorPageDonorPassSpanish;
      this.donorPageBarcode = donorPageBarcodeSpanish;
      this.donorPassThankYou = donorPassThankYouSpanish;
      this.donorPassExpire = donorPassExpireSpanish;
      this.donorPassDownload = donorPassDownloadSpanish;
      this.donorPassPrint = donorPassPrintSpanish;
      this.donorPassEmail = donorPassEmailSpanish;
      this.donorPassReturnTo = donorPassReturnToSpanish;
      this.donorPassStartOver = donorPassStartOverSpanish;
      this.xpressDialogNavToBarcodeTitle = xpressDialogNavToBarcodeTitleSpanish;
      this.xpressDialogNavToBarcodeText = xpressDialogNavToBarcodeTextSpanish;
      this.xpressDialogNavToBarcodeOk = xpressDialogNavToBarcodeOkSpanish;
      this.xpressDialogNavToBarcodeCancel = xpressDialogNavToBarcodeCancelSpanish;
      this.xpressDialogSendEmailTitle = xpressDialogSendEmailTitleSpanish;
      this.xpressDialogSendEmailText = xpressDialogSendEmailTextSpanish;
      this.xpressDialogSendEmailSend = xpressDialogSendEmailSendSpanish;
      this.xpressDialogSendEmailCancel = xpressDialogSendEmailCancelSpanish;
      this.xpressDialogValidDateTitle = xpressDialogValidDateTitleSpanish;
      this.xpressDialogValidDateText = xpressDialogValidDateTextSpanish;
      this.xpressDialogValidDateOk = xpressDialogValidDateOkSpanish;
      this.xpressDialogPreScreenTitle = xpressDialogPreScreenTitleSpanish;
      this.xpressDialogPreScreenText = xpressDialogPreScreenTextSpanish;
      this.xpressDialogPreScreenOk = xpressDialogPreScreenOkSpanish;
      this.xpressPoweredBy = poweredBySpanish;
      this.fileDownloadedModalText = fileDownloadedModalTextSpanish;
      this.fileDownloadedModalTitle = fileDownloadedModalTitleSpanish;
      this.xpressEmailModalText = xpressEmailModalTextSpanish;
      this.xpressDialogEmailSuccessMessage = xpressDialogEmailSuccessMessageSpanish;
      this.xpressDialogEmailInvalidMessage = xpressDialogEmailInvalidMessageSpanish;
      this.xpressDialogTitleError = xpressDialogTitleErrorSpanish;
      this.xpressDialogTitleWarning = xpressDialogTitleWarningSpanish;
    }
  }

  static get homePageGetStartedEnglish() {
    return 'Select a language to begin';
  }

  static get homePageGetStartedSpanish() {
    return 'Seleccione un idioma para comenzar';
  }
}
  
export default TranslationConstants;

// Define constants for use when a language has not been selected yet
export const homePageGetStartedEnglish = TranslationConstants.homePageGetStartedEnglish;
export const homePageGetStartedSpanish = TranslationConstants.homePageGetStartedSpanish;